import React from 'react';
import { Icon, SemanticCOLORS, SemanticICONS } from 'semantic-ui-react';
import { IconSizeProp } from 'semantic-ui-react/dist/commonjs/elements/Icon/Icon';

export enum FileTypes {
  INVALID_FILE_TYPE = -1,
  PDF = 0,
  MP4 = 1,
  URL = 2,
}

export const FILE_TYPES = {
  [FileTypes.INVALID_FILE_TYPE]: 'invalid',
  [FileTypes.PDF]: 'pdf',
  [FileTypes.MP4]: 'mp4',
  [FileTypes.URL]: 'link',
};

export const FILE_TYPE_ICONS: { [key: number]: string } = {
  [FileTypes.PDF]: 'file pdf outline',
  [FileTypes.MP4]: 'file video outline',
  [FileTypes.URL]: 'linkify',
};

export const FILE_TYPE_COLORS = {
  [FileTypes.PDF]: 'red',
  [FileTypes.MP4]: 'blue',
  [FileTypes.URL]: 'green',
};

export const getFileTypeIcon = (
  type: FileTypes,
  options?: { size?: IconSizeProp; style?: React.CSSProperties }
) => {
  if (type === FileTypes.INVALID_FILE_TYPE) return null;

  return (
    <Icon
      name={FILE_TYPE_ICONS[type] as SemanticICONS}
      color={FILE_TYPE_COLORS[type] as SemanticCOLORS}
      size={options?.size ?? 'large'}
      style={{ marginRight: '.5em', ...options?.style }}
    />
  );
};
